import MtsTakipAc from "../../../takip_ac/MtsTakipAc";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TaskDurum} from "../../../enum/TaskDurum";
import {MtsXmlParser} from "@/plugins/uyap-plugin/takip_ac/MtsXmlParser";

export class MtsTakipTevziAlTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let takip = MtsTakipAc.fromJson(task.data);
            takip.parsedFile = MtsXmlParser.fromJson(task.data.parsedFile);
            await takip.takipBaslatYeni(false,false);
            task.response = takip;
            // Harç muaf dosyada takip bu görevde açılır; açıldıktan sonra hash kaydı güncellenemezse
            // görev hatalı değil, eksik biter ve neden açıklamaya yazılır (DEV-3302).
            // icraProSenkronHatasi burada bilerek okunmuyor: yalnız tevzi alınan (açılmamış) dosyada
            // da kart senkronu denenebiliyor (MTS'te esas no yerine "Dosya tevzi alındı..." metniyle);
            // bayrak dolarsa EKSIK satır "Seçilen Takipleri Aç" listesinden düşerdi.
            task.status = takip.hashGuncellemeHatasi ? TaskDurum.BITTI_EKSIK : TaskDurum.BITTI_BASARILI;
            if (task.status == TaskDurum.BITTI_EKSIK)
                task.description = takip.eksikBitisAciklamasi(false);
            return task;
        } catch (e) {
            console.log(e);
            throw new Error(e.message);
        }
    }
}